import { PropsWithChildren, createContext, useContext, useState } from 'react';

type HipaaSignatureContextState = [string, (s: string) => void];
const HipaaSignatureContext = createContext<HipaaSignatureContextState>([
    '',
    () => undefined,
]);

export function useHipaaSignature() {
    const state = useContext(HipaaSignatureContext);
    return state;
}

export function HipaaSignatureProvider({ children }: PropsWithChildren) {
    const [signature, setSignature] = useState<string>('');
    const setter = (s: string) => setSignature(s);
    return (
        <HipaaSignatureContext.Provider value={[signature, setter]}>
            {children}
        </HipaaSignatureContext.Provider>
    );
}
